import { FC } from 'react';
import { Button, Spinner, OverlayTrigger, Popover } from "react-bootstrap";
import { t } from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

interface IProps {
  isLoading?: boolean;
  disabled?: boolean;
  titlePopOver?: string;
  onClick: (event: any) => Promise<void>;
}

const styleButtonInfo = { marginLeft: 10 }

const ButtonInfo: FC<IProps> = ({
  isLoading,
  disabled,
  titlePopOver,
  onClick
}) => {
  return (

    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={
        <Popover>
          <Popover.Body>
          {titlePopOver}
          </Popover.Body>
        </Popover>
      }>
        <Button
         style={styleButtonInfo}
         disabled={disabled || isLoading || false}
         type="button"      
         onClick={(e) => onClick(e)}>
         {isLoading &&
           <Spinner
             as="span"
             animation="border"
             size="sm"
             role="status"
             aria-hidden="true"
           />
         }
         &nbsp;<FontAwesomeIcon icon={faInfoCircle} className='me-1' />      
       </Button>
    </OverlayTrigger>
  );
}

export default ButtonInfo;